export const getEnterEvent = (detail?: number) =>
  new KeyboardEvent("keydown", {
    detail,
    bubbles: true,
    cancelable: true,
    key: "Enter"
  })
